<div [ngClass]="'active-' + activeIndex" class="sidebar">
  <div class="sidebar-title">SECTIONS</div>
  <div class="sidebar-content">
    <div class="sidebar-line"></div>
    <div class="sidebar-items" fxLayout="column" fxLayoutGap="8px">
      <div
        (click)="scrollTo(section.id)"
        *ngFor="let section of sections"
        [class.active]="activeSectionId === section.id"
        class="sidebar-item"
      >
        {{ section.label }}
      </div>
    </div>
  </div>
</div>
